<template lang='pug'>
div(:class='$style[`cc-userFeature-board-container`]')
  div(:class='$style[`cc-userFeature-board-list`]')
    //- button(
    //-   title='建立新內容'
    //-   tabindex='0'
    //-   aria-label='建立新內容'
    //-   :class='$style[`cc-userFeature-board-nav`]'
    //-   @click='handleBuildNewPost')
    //-   IconWrite(:size='26' :color='`#6f6f6f`')
    //-   span!= '建立'

    router-link(
      v-if='loginProfile.user_type === `normal`'
      tag='button'
      tabindex='0'
      aria-label='交易紀錄'
      title='交易紀錄'
      :class='$style[`cc-userFeature-board-nav`]'
      :to='`/orders`')
      IconMoney(:size='26' :color='`#6f6f6f`')
      span 交易紀錄

    //- 癌友故事卡
    //- router-link(
    //-   v-if='loginProfile.user_type === `normal`'
    //-   tag='button'
    //-   tabindex='0'
    //-   aria-label='我的故事卡'
    //-   title='我的故事卡'
    //-   :class='$style[`cc-userFeature-board-nav`]'
    //-   :to='{ name: `profile-resume`, params: { type: `normal`, id: `${loginDjangoId}` }}')
    //-   IconResumeCard(:size='26' :color='`#6f6f6f`')
    //-   span!= '我的故事卡'

    //- 查看討論板
    //- router-link(
    //-   title='討論板'
    //-   tag='button'
    //-   tabindex='0'
    //-   aria-label='討論板'
    //-   :class='$style[`cc-userFeature-board-nav`]'
    //-   :to='{ name: `profile-record`, params: { type: `${loginProfile.user_type}`, id: `${loginDjangoId}` } }')
    //-   IconDialog(:size='26' :color='`#6f6f6f`')
    //-   span!= '討論板'

    //- 收藏區
    //- router-link(
    //-   title='我的收藏區'
    //-   tag='button'
    //-   tabindex='0'
    //-   aria-label='我的收藏區'
    //-   :class='$style[`cc-userFeature-board-nav`]'
    //-   :to='{ name: `profile-bookmark`, params: { type: `${loginProfile.user_type}`, id: `${loginDjangoId}` } }')
    //-   IconBookMark(:size='26' :color='`#6f6f6f`')
    //-   span!= '收藏區'


    //- 更改標籤主題
    //- button(
    //-   title='修改最愛標籤'
    //-   tabindex='0'
    //-   aria-label='修改最愛標籤'
    //-   :class='$style[`cc-userFeature-board-nav`]'
    //-   @click.passive='handleClickModifiedTags')
    //-   IconTag(:size='26' :color='`#6f6f6f`')
    //-   span 最愛標籤


    //- 追蹤我的人
    //- router-link(
    //-   v-if='loginProfile.user_type === `doctor`'
    //-   tag='button'
    //-   tabindex='0'
    //-   aria-label='追蹤我的人'
    //-   title='追蹤我的人'
    //-   :class='$style[`cc-userFeature-board-nav`]'
    //-   :to='{ name: `profile-follower`, params: { type: `${loginProfile.user_type}`, id: `${loginDjangoId}` } }')
    //-   IconFollower(:size='26' :color='`#6f6f6f`')
    //-   span 追蹤我的人


    //- 追蹤的醫生
    //- router-link(
    //-   v-if='loginProfile.user_type === `normal`'
    //-   title='追蹤的醫生'
    //-   :class='$style[`cc-userFeature-board-nav`]'
    //-   :to='{ name: `profile-following`, params: { type: `${loginProfile.user_type}`, id: `${loginDjangoId}` } }')
    //-   IconFollowDoctor(:size='26' :color='`#6f6f6f`')
    //-   span!= '追蹤的醫生'

  div(:class='$style[`cc-userFeature-board-feedback`]')
    router-link.btn-extra(
      title='問題回報 / 意見回饋'
      tag='button'
      tabindex='0'
      aria-label='前往問題回報與意見回饋'
      :class='$style[`cc-userFeature-board-nav`]'
      to='/feedback')
      //- IconDialog(:size='24' :color='`#6f6f6f`')
      span 問題回報 / 意見回饋
    //- button.btn-extra(
    //-   title='問題回報 / 意見回饋'
    //-   tabindex='0'
    //-   aria-label='建立新內容'
    //-   :class='$style[`cc-userFeature-board-nav`]'
    //-   @click='handleBuildNewPost')
    //-   IconDialog(:size='26' :color='`#6f6f6f`')
    //-   span!= '問題回報 / 意見回饋'

  div(:class='$style[`cc-userFeature-board-cancell`]')
    div(:class='$style[`cc-userFeature-board-cancell-title`]')
      span 其他服務

    //- router-link(
    //-   title='排行榜'
    //-   :to='`/rank`'
    //-   :class='$style[`cc-userFeature-board-nav`]')
    //-   IconRank(:size='32')
    //-   span!= '排行榜'
    a(
      title='Youtube'
      :href='`https://www.youtube.com/channel/UC1P4dlvDP8sYlXvjrhaOlqA`'
      :class='$style[`cc-userFeature-board-nav`]')
      IconYoutube(:size='32')
      span Youtube

    a(
      title='Cancell粉絲專頁'
      :href='`https://www.facebook.com/cancelltw`'
      :class='$style[`cc-userFeature-board-nav`]')
      IconFacebook(:size='32')
      span 粉絲專頁

    a(
      title='官方Line帳號'
      :href='`https://lin.ee/eEea6j5`'
      :class='$style[`cc-userFeature-board-nav`]')
      IconLine(:size='32')
      span 官方Line

</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
// import * as jwt_decode from 'jwt-decode';

import IconFollowDoctor from '../../icon/FollowDoctor';
import IconFollower from '../../icon/Follower';
import IconTag from '../../icon/Tag';
import IconWrite from '../../icon/Write';
import IconLogOut from '../../icon/LogOut';
import IconDialog from '../../icon/Dialog';
import IconResumeCard from '../../icon/ResumeCard';
import IconMoney from '../../icon/Money';
import IconBookMark from '../../icon/Bookmark';
import IconFacebook from '../../icon/Facebook';
import IconLine from '../../icon/Line';
import IconMessenger from '../../icon/Messenger';
import IconYoutube from '../../icon/Youtube';
// import IconRank from '../../icon/Rank';
// import IconDonate from '../../icon/Donate';

export default {
  components: {
    IconFollowDoctor,
    IconFollower,
    IconTag,
    IconWrite,
    IconDialog,
    IconLogOut,
    IconBookMark,
    IconResumeCard,
    IconMoney,
    IconFacebook,
    IconLine,
    IconMessenger,
    IconYoutube,
    // IconRank,
    // IconDonate,
  },

  methods: {
    ...mapActions({
      // changeLoginStatus: 'user/userLoginMember',
      changeUserFeature: 'user/changeTopBarUserFeatureFocus',
    }),

    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    // handleClickModifiedTags() {
    //   this.$router.push({
    //     name: 'select-tags',
    //     params: {
    //       type: this.loginProfile.user_type,
    //       username: this.loginProfile.email,
    //       hashcode: this.loginHashCode,
    //     },
    //   }).catch(() => true);
    // },

    // handleBuildNewPost() {
    //   this.changePopBoxStatus({
    //     active: true,
    //     include: 'newBuild',
    //   });
    // },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginHashCode: 'user/exportUserHashCode',
      loginDjangoId: 'user/exportUserDjangoId',
      loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
   @import '../../../sass/component/page/topbar/boardUserFeature.scss';
</style>
